var React = require('react');

function Hu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#fff","d":"M640 480H0V0h640z","key":0}),React.createElement("path",{"fill":"#388d00","d":"M640 480H0V320h640z","key":1}),React.createElement("path",{"fill":"#d43516","d":"M640 160.1H0V.1h640z","key":2})]));
}

Hu.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Hu;

Hu.default = Hu;
